import { SxProps, Theme } from '@mui/material';

export const AccountInformationFormTitleSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
	marginBottom: theme.spacing(3),
});

export const AccountInformationFormEmailSX: SxProps = { marginBottom: 1 };

export const AccountInformationFormCheckboxSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-small)',
	color: '#2C2C2C',
});

export const AccountBlockedEmailSX: SxProps = {
	'& .MuiOutlinedInput-root': {
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#C9C9C9',
			borderWidth: '1px',
		},
		'& .MuiOutlinedInput-input': {
			color: '#2C2C2C',
		},
	},
	'& .MuiInputLabel-root': {
		color: '#2C2C2C',
		'&.Mui-focused': {
			color: '#2C2C2C',
		},
	},
};

export const FormControlLabelSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	marginLeft: 0,
	marginTop: { xs: 2, md: 0 },
	paddingRight: { xs: 0, md: '5px' },
};

export const AccountInformationBpCheckboxSX: SxProps = {
	paddingRight: 0.5,
	paddingLeft: 0,
	marginBottom: { xs: 2.5, md: 0 },
	paddingY: { xs: 0, md: 2 },
};
